import React, {useState, useEffect} from 'react';

function slideSystem(slides, lifecycleFunctions = {}, addon) {
	useEffect(() => {
		scrollToTop();
	}, []);
	let {courseInfo} = addon;
	let {done, next, back} = lifecycleFunctions;

	let [slideIndex, setSlideIndex] = useState(0);
	let CurrentSlide = slides[slideIndex];

	return (
		<CurrentSlide
			nextPressed={nextPressed}
			backPressed={backPressed}
			nextSlideExzists={nextSlideExzists}
			previousSlideExzists={previousSlideExzists}
			courseInfo={courseInfo}
		/>
	);

	function nextPressed() {
		if (next) {
			next();
		}
		if (nextSlideExzists()) {
			setSlideIndex(slideIndex + 1);
		} else {
			if (done) {
				done();
			}
		}
	}

	function backPressed() {
		if (back) {
			back();
		}
		if (previousSlideExzists()) {
			setSlideIndex(slideIndex - 1);
		} else {
			alert('No more slides avalible');
		}
	}

	function nextSlideExzists() {
		if (slideIndex + 1 < slides.length) {
			return true;
		}
		return false;
	}

	function previousSlideExzists() {
		if (slideIndex - 1 < 0) {
			return false;
		}
		return true;
	}
}

function scrollToTop() {
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}

	window.scrollTo(0, 0);
}

export default slideSystem;
